export default __webpack_public_path__ + "static/media/Group840.611d5037.svg";